import React, { FunctionComponent } from "react";
import { Box, Stack, useTheme } from "@mui/material";
import { strings } from "../../../localization/LocalizedStrings";
import styles from "./styles.module.scss";
import { Icon, IconType } from "../../../icons";

export const NoneSelectItem: FunctionComponent = () => {
  const theme = useTheme();
  return (
    <Stack direction={"row"} style={{ color: theme.palette.primary.subtitle, minWidth: "150px" }}>
      <div className={styles.icon}>
        <Icon type={IconType.Close} />
      </div>
      <Box style={{ width: "14px" }} />
      {strings.none}
    </Stack>
  );
};
